import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import ReconciliationDetail from "../../components/Reconciliation/detail";

const ReconciliationDetailPage: FC = () => {
  return <ReconciliationDetail />
};

export default ReconciliationDetailPage;
